import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  TextInput,
  SelectInput,
} from "../../components/common/UI/Inputs/InputControls";
import DatePickerComponent from "../../components/common/UI/Inputs/InputControls/DateInput.jsx";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import { sendPhotosActions, myContactsActions } from "../../_store";
import useDraft from '../../components/common/autoSaveDraftMsg/useDraft';
import ConfirmationModal from "../../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup";
import { ReactNotifications } from "react-notifications-component";
import useFullPageLoader from "../../hooks/useFullPageLoader.jsx";
import translations from '../../config/TranslateFile.jsx'
import { EventLog } from "../../components/common/EventLog/EventLog.jsx";
import { CreateEventLogTextFileForInbox } from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import { getStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";
import messageRead from "../../assets/images/double-tick-indicator.png";
import messagesent from "../../assets/images/tick.png";

const SendPhotos = () => {
  const userID = getStoredValue("userID");
  const currentMenuName = useSelector((x) => x.master.currentMenuName);
  const defaultParams = {
    userID: userID,
    messageID: 0,
    ReceiverRead: 2,
    InmateID: 0,
    FromDate: "",
    ToDate: "",
    MessageStatus: 0,
    subject: "",
    MessageBody: "",
    pageNo: 1,
    rowCountPerPage: 10,
    sortField: "PhotoCommID Desc",
  };
  const currentLang = translations();
  const [showSearchFields, setShowSearchFields] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  // Auto Draft save
  const { setIsSaveDraftModified } = useDraft();
  const [hasMoreData, setHasMoreData] = useState(true);
  const [pageNo, setPageNo] = useState(1); // Current page number
  const [searchpageNo, setSearchpageNo] = useState(0);
  const [isSearch, setIsSearch] = useState(false);

  const [loadedPages, setLoadedPages] = useState(new Set());
  const [searchloadedPages, setSearchLoadedPages] = useState(new Set());
  const [isPurchaseHistoryConfirm, setIsPurchaseHistoryConfirm] = useState(false);
  const [purchaseCreditInmateID, setPurchaseCreditInmateID] = useState(false);
  const [paymentMsg, setPaymentMsg] = useState("");
  const [isPaymentMsg, setIsPaymentMsg] = useState(false);
  const MsgPhotoStatusResponse = useSelector((state) => state.sendPhotos.CheckingMsgPhotoStatusResponse);
  const { isSignalRData } = useSelector((state) => state.auth);

  useEffect(() => {
    const savedDraft = getStoredValue('draft');
    if (savedDraft != null) {
      setIsSaveDraftModified(true);
    }
  }, [setIsSaveDraftModified]);


  const InmateDrpList = useSelector(
    (x) => x.myContacts.PublicMyContactsDisplayNew
  );

  const { loading } = useSelector((state) => state.sendPhotos);
  // State to store filtered results
  const [filteredPhotos, setFilteredPhotos] = useState([]);
  const [previousFilteredPhotos, setPreviousFilteredPhotos] = useState([]);

  // useEffect(() => {
  //   setPreviousFilteredPhotos(filteredPhotos); // Save the current filteredPhotos as the previous state
  // }, [filteredPhotos]);
  const StatusOptions = [
    { value: "1", label: currentLang?.DropDown?.All },
    { value: "2", label: currentLang?.DropDown?.Read },
    { value: "3", label: currentLang?.DropDown?.Unread },
    { value: "4", label: currentLang?.DropDown?.Rejected },
    { value: "5", label: currentLang?.DropDown?.Waiting },
  ];
  // Initial state for findPhotos
  const InitialFindPhoto = {
    userID: userID,
    InmateID: 0,
    FromDate: "",
    ToDate: "",
    MessageStatus: 0,
    Subject: "",  // Ensure this is set to an empty string initially
    StatusOptions: "1",  // Default to "All"
  }
  const [findPhotos, setFindPhotos] = useState(InitialFindPhoto);
  const [pendingSearch, setPendingSearch] = useState(null);
  useEffect(() => {
    if (location.state?.findPhotos) {
      // Extract and set default search parameters
      const defaultSearchParams = {
        FromDate: location.state.findPhotos.FromDate || "",
        InmateID: location.state.findPhotos.InmateID || 0,
        ToDate: location.state.findPhotos.ToDate || "",
        Subject: location.state.findPhotos.Subject || "",
        StatusOptions: location.state.findPhotos.StatusOptions || "",
        MessageStatus: location.state.findPhotos.MessageStatus || 0,
        userID: location.state.findPhotos.userID || "",
      };

      // Update state with the merged values
      setFindPhotos((prev) => ({
        ...prev,
        ...defaultSearchParams,
      }));

      // Determine selected inmate and handle search logic
      if (Array.isArray(InmateDrpList)) {
        const filteredContacts = InmateDrpList.filter(
          (item) => item.value === parseInt(location.state.findPhotos.InmateID, 10)
        );

        if (filteredContacts.length === 1) {
          const data = filteredContacts[0];
          handleSelectChange(data, "InmateID");
          setShowSearchFields(true);
          setPendingSearch({ value: data.value });
        } else {
          setShowSearchFields(true);
          setPendingSearch({ value: 0 });
        }
      }
    }
  }, [location.state, InmateDrpList]);

  useEffect(() => {

    switch (isSignalRData?.type) {
      case 'Read_Photo':
        const updatedPhotos = filteredPhotos?.map(card => {
          if (card?.PhotoCommID === isSignalRData?.message?.PhotoAccess) {
            return { ...card, PhotoReadStatus: "Read" };
          }
          return card;
        });
        setFilteredPhotos(updatedPhotos);
        break;
      case 'Approve_Photo':
        const updatedApprovePhotos = filteredPhotos?.map(card => {
          if (card?.PhotoCommID === isSignalRData?.message?.PhotoCommID) {
            return { ...card, PhotoReadStatus: "Unread" };
          }
          return card;
        });
        setFilteredPhotos(updatedApprovePhotos);
        break;

      case 'Reject_Photo':
        const updatedRejectedPhotos = filteredPhotos?.map(card => {
          if (card?.PhotoCommID === isSignalRData?.message?.PhotoCommID) {
            return { ...card, PhotoReadStatus: "Rejected" };
          }
          return card;
        });
        setFilteredPhotos(updatedRejectedPhotos);
        break;
    }

  }, [isSignalRData]);

  useEffect(() => {
    if (pendingSearch !== null) {
      handleSearch(false, pendingSearch.value);
      setPendingSearch(null); // Reset after execution
    }
  }, [pendingSearch]);


  const LoadSentPhotos = useCallback(async () => {
    try {
      showLoader();
      // Load initial messages when component mounts
      const response = await dispatch(
        sendPhotosActions.PublicSentItemPhotoWeb({
          ...defaultParams,
          pageNo: 1, // Pass the updated page number
          append: true, // Indicate this call is for appending data
        })
      );

      if (response.payload && response.payload.length > 0) {
        const infoMessage = "Load Sent Photos List - Sent Photos Menu ";
        const redirectURL = "---";
        const Status = "---";
        const Response = JSON.stringify(response?.payload);
        EventLog(dispatch, infoMessage, redirectURL, Response, Status);
        hideLoader();
        setFilteredPhotos(response.payload); // Update the state
        setHasMoreData(true); // Allow "Load More" if more data exists
        if (response?.payload?.length < defaultParams?.rowCountPerPage) {
          setHasMoreData(false); // No more data available, hide "Load More"
        }
      } else {
        hideLoader();
        setHasMoreData(false); // No more data available
        setIsSearch(true);
      }
    } catch (error) {
      hideLoader();
    }
  }, [dispatch]);

  const ResetState = () => {
    const updatedState = {
      ...location.state,
      findPhotos: undefined
    };
    // Navigate to the current path with the updated state
    navigate(location.pathname, { state: updatedState });
    storeCurrentRoute(location.pathname);
  }

  // Helper function to validate the date
  const isValidDate = (date) => {
    return !isNaN(new Date(date).getTime());
  };

  // Handle date input change with validation
  const handleDateChange = (date, field) => {
    // Create a Date object and check if it's valid
    const parsedDate = new Date(date);
    const currentDate = new Date();

    // Check if the year is valid (>= 1990) and date is not in the future
    const isValidYearAndDate = isValidDate && parsedDate.getFullYear() >= 1990 && parsedDate <= currentDate;
    const formattedDate = date && isValidDate(date) && isValidYearAndDate
      ? new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date(date))
      : null;

    setFindPhotos((prev) => {
      const newState = {
        ...prev,
        [field]: formatDate(formattedDate), // If invalid date, set to empty string
      };

      // Validation logic for FromDate and ToDate
      if (field === 'FromDate' && newState.FromDate && newState.ToDate) {
        const fromDateObj = new Date(newState.FromDate);
        const toDateObj = new Date(newState.ToDate);
        if (fromDateObj > toDateObj) {
          newState.FromDate = ""; // Reset FromDate if it's greater than ToDate
        }
      }

      if (field === 'ToDate' && newState.ToDate && newState.FromDate) {
        const fromDateObj = new Date(newState.FromDate);
        const toDateObj = new Date(newState.ToDate);
        if (toDateObj < fromDateObj) {
          newState.ToDate = ""; // Reset ToDate if it's less than FromDate
        }
      }

      return newState;
    });
  };

  const formatDate = (date) => {
    if (date !== null) {
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, '0'); // Get month and pad with leading zero if necessary
      const day = String(d.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
      const year = d.getFullYear(); // Get the full year
      return `${month}/${day}/${year}`; // Return the formatted date
    }
    else {
      return null;
    }
  };

  // OnBlur validation for FromDate and ToDate
  const handleBlur = (e, field) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (field === "FromDate") {
      if (findPhotos?.ToDate && new Date(value) > new Date(findPhotos?.ToDate)) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (field === "ToDate") {
      if (findPhotos?.FromDate && new Date(value) < new Date(findPhotos?.FromDate)) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = new Date("2017-01-01");
    const today = new Date();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...findPhotos,
      FromDate:
        field === "FromDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : findPhotos?.FromDate, // preserve existing value
      ToDate:
        field === "ToDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : findPhotos?.ToDate, // preserve existing value
    };
    setFindPhotos(updatedParam);
  };

  const handleCancelPurchaseHist = () => {
    setIsPurchaseHistoryConfirm(false);
    CreateEventLogTextFileForInbox(
      dispatch,
      `${currentMenuName} - Clicked ${"NO"} option In Redirect into Purchase Credit confirmation Popup`,
      "---",
      "---",
      "Hided confirmation Popup"
    );
  };

  const handleChange = (e, field) => {
    setFindPhotos((prev) => ({
      ...prev,
      [field]: e.target.value,  // Update the specific field in state
    }));
  };

  const handleSelectChange = (selectedOption, field) => {
    const updatedValue = selectedOption?.value ?? (field === "StatusOptions" ? "1" : 0);

    // Update state immutably
    setFindPhotos((prev) => ({
      ...prev,
      [field]: updatedValue,
    }));

    // Log the immediate new state for verification
    const newState = { ...findPhotos, [field]: updatedValue };
  };



  useEffect(() => {
    let inmatesId = 0;
    // let userID = UserId;
    let userId = getStoredValue("userID");
    let activeStatus = 0;
    let sortField = "InmateName asc";
    let inmateLoadPurpose = "All";
    dispatch(
      myContactsActions.PublicMyContactsDisplayNew({
        userId,
        inmatesId,
        inmateLoadPurpose,
        activeStatus,
        sortField,
      })
    );
  }, [dispatch]);

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };
  const handleClick = (photo) => {
    CreateEventLogTextFileForInbox(
      dispatch,
      "Load photos details ( PhotoCommID - " + photo?.PhotoCommID + " ) ",
      "---",
      JSON.stringify(photo),
      "---"
    );

    navigate("/public/Profile", { state: { PhotoCommID: photo.PhotoCommID, findPhotos: findPhotos } });
    storeCurrentRoute("/public/Profile");
  };

  const getStatusString = (statusValue) => {
    switch (statusValue) {
      case "2":
        return "Read";
      case "3":
        return "Unread";
      case "4":
        return "Rejected";
      case "5":
        return "Waiting";
      default:
        return "All"; // For "1" or any unexpected values, treat as "All"
    }
  };
  const handleLoadMore = async () => {
    // Calculate the new page number
    const newPageNo = pageNo + 1;

    // Check if the page has already been loaded to prevent re-fetching
    if (loadedPages.has(newPageNo)) {
      setHasMoreData(false);
      return;
    }
    try {
      // Fetch new data using dispatch
      const response = await dispatch(
        sendPhotosActions.PublicSentItemPhotoWeb({
          ...defaultParams,
          pageNo: newPageNo, // Pass the updated page number
          append: true,       // Indicate this call is for appending data
        })
      );

      // Handle the response
      if (response.payload && response.payload.length > 0) {
        setFilteredPhotos((prev) => [...prev, ...response.payload]); // Append new data to existing data
        const infoMessage = "Load Photos details ";
        const redirectURL = "---";
        const Status = "---";
        const Response = JSON.stringify(response?.payload);
        EventLog(dispatch, infoMessage, redirectURL, Response, Status);
        // Update loaded pages to prevent fetching the same page again
        setLoadedPages((prevLoadedPages) => {
          const updatedLoadedPages = new Set(prevLoadedPages);
          updatedLoadedPages.add(newPageNo);
          return updatedLoadedPages;
        });

        // Update page number state for future requests
        setPageNo(newPageNo);

        // If fewer items are returned than requested, stop loading
        if (response.payload.length < defaultParams.rowCountPerPage) {
          setHasMoreData(false); // No more data available, hide "Load More"
        }
      } else {
        // Stop loading if no data is returned
        setHasMoreData(false);
      }
    } catch (error) {
      console.error("Error loading more data:", error);
    }
  };

  const handleSearch = async (IsLoadMore, InmateIDFilter) => {
    showLoader();
    // Calculate the new page number
    let newPageNo = 1;
    setIsSearch(true);

    if (IsLoadMore) {
      newPageNo = searchpageNo + 1;
      if (searchloadedPages.has(newPageNo)) {
        setHasMoreData(false);
        return;
      }
    } else {
      setFilteredPhotos([]);
      const resetLoadedPages = new Set();
      resetLoadedPages.add(newPageNo); // Add the first page to prevent duplicate fetches
      setSearchLoadedPages(resetLoadedPages);
    }

    const { InmateID, FromDate, ToDate, Subject, StatusOptions } = findPhotos;
    const statusFilter = getStatusString(StatusOptions); // Convert StatusOptions to the appropriate value

    try {
      // Prepare the request payload based on defaultParams and the search filters
      const requestPayload = {
        ...defaultParams, // Spread the defaultParams to maintain initial values
        InmateID: InmateIDFilter !== null && InmateIDFilter != undefined ? InmateIDFilter : InmateID,
        FromDate: FromDate != "" && FromDate != null ? formatDate(FromDate) : "",
        ToDate: ToDate != "" && ToDate != null ? formatDate(ToDate) : "",
        MessageStatus: statusFilter === "All" ? 0 : StatusOptions, // Adjust MessageStatus based on filter
        subject: Subject,
        pageNo: newPageNo, // Always start with page 1 for the search
        rowCountPerPage: 10, // Set the number of rows per page
      };

      // Call the API to fetch the filtered data
      const response = await dispatch(
        sendPhotosActions.PublicSentItemPhotoWeb({
          ...requestPayload,
          append: true, // Indicate this is not for appending
        })
      );


      if (response.payload && response.payload.length > 0) {
        CreateEventLogTextFileForInbox(
          dispatch,
          `Searched  Sent Photos List Using - InmateID " ${InmateID} " MessageSubject-" ${Subject} "FromDate" ${FromDate} "ToDate" ${ToDate} "Status" ${StatusOptions}`,
          "---",
          JSON?.stringify(response?.payload),
          " Message Count - " + response?.payload?.length
        );

        hideLoader();
        if (newPageNo === 1) {
          setHasMoreData(true);
          setFilteredPhotos([]);
          // Ensure the clearing takes effect before setting new data
          setTimeout(() => {
            setFilteredPhotos(response.payload);
          }, 0);
        } else {
          setFilteredPhotos((prev) => [...prev, ...response.payload]); // Append new data to existing data
        }

        // Update loaded pages to prevent fetching the same page again
        setSearchLoadedPages((prev) => {
          const updatedSearchLoadedPages = new Set(prev);
          updatedSearchLoadedPages.add(newPageNo);
          return updatedSearchLoadedPages;
        });

        // Update page number state for future requests
        setSearchpageNo(newPageNo); // Increment page number for next load

        // If fewer items are returned than requested, stop loading
        if (response.payload.length < defaultParams.rowCountPerPage) {
          setHasMoreData(false); // No more data available, hide "Load More"
        }
      } else {
        // Stop loading if no data is returned
        setHasMoreData(false);
        hideLoader();
        CreateEventLogTextFileForInbox(
          dispatch,
          `Searched  Sent Photos List Using - InmateID " ${InmateID} " MessageSubject-" ${Subject} "FromDate" ${FromDate} "ToDate" ${ToDate} "Status" ${StatusOptions}`,
          "---",
          JSON?.stringify(response?.payload),
          " No data Found"
        );
      }
    } catch (error) {
      hideLoader();
      console.error("Error fetching search data:", error);
    }

  };


  // Reset to clear state and show all items
  const handleReset = () => {

    CreateEventLogTextFileForInbox(
      dispatch,
      `Reset Button clicked in Sent Photos List - ${filteredPhotos?.length} Records per page "`,
      "---",
      JSON?.stringify(filteredPhotos),
      " Message Count - " + filteredPhotos?.length
    );


    setIsSearch(false);
    setFindPhotos(InitialFindPhoto); // Reset findPhotos to initial state
    LoadSentPhotos();
    ResetState();
  };

  const handleClickRedirect = (event, InmateID) => {
    event.stopPropagation();  // Prevent event from bubbling up
    setIsPurchaseHistoryConfirm(true);
    setPurchaseCreditInmateID(InmateID);
    CreateEventLogTextFileForInbox(
      dispatch,
      "Show Confirmation Photo Popup to Purchase Credit ( Inmate ID - " + InmateID + " ) ",
      "---",
      "This action redirects into another page, Are you sure you want to proceed?",
      "---"
    );
  };

  const handlePaymentMsg = () => {
    setIsPaymentMsg(false);
  };

  useEffect(() => {
    if (!location.state?.findPhotos) {
      LoadSentPhotos();
    }
  }, [])

  // Purchase Credit status checking
  useEffect(() => {
    if (MsgPhotoStatusResponse.length === undefined) {
      const { Result, Notes } = MsgPhotoStatusResponse;
      setIsPurchaseHistoryConfirm(false);
      LoadSentPhotos();
      switch (Result) {
        case -7:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Connection_Blocked)
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -8:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.No_longer_connected)
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -6:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Contact)
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -4:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Facility)
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -3:
          setPaymentMsg(Notes);
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        default:
          if (Result === 0) {
            if (Result === 0) {
              CreateEventLogTextFileForInbox(
                dispatch,
                `${currentMenuName} - Redirect into Purchase Credits page to Purchase Credits for Inmate ( Inmate ID - ${purchaseCreditInmateID} ) `,
                "/public/PurchaseCredits",
                "---",
                "---"
              );
              setStoredValue("InmateID", purchaseCreditInmateID);
              navigate("/public/PurchaseCredits", {
                state: { previousPath: location.pathname },
              });
              storeCurrentRoute("/public/PurchaseCredits");
              dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());

            }
          }
          break;
      }
    }
  }, [MsgPhotoStatusResponse]);


  const handleClickPurchaseCreditRedirect = () => {
    showLoader();
    dispatch(sendPhotosActions.CheckingMsgPhotoStatus({ addFormData: { UserID: userID, InmateID: purchaseCreditInmateID } })).then((x) => {
      hideLoader();
    })
  };


  return (
    <>
      <ReactNotifications />
      <div>
        <div className="header-title">
          <h5>
            {/* <i className="fa fa-paper-plane me-2"></i> */}
            {currentLang?.sendphotos}
          </h5>
        </div>
      </div>

      <div className="row mb-5 pb-mobile">
        <div className="col-md-12">
          <ul className="list-group" id="divLoadList">
            <div className="card border-radius-all shadow-sm">
              <div
                className="card-header d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleInformation}
              >
                <h4 className="mb-0 text-dark">
                  <i className="fa fa-search me-2" style={{ fontSize: "16px" }}></i> {currentLang?.header?.Search}
                </h4>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""}`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
              {showSearchFields && (
                <div className="card-body bg-white padding-20">
                  <div className="row">
                    {/* Inmate Name */}
                    <div className="col-md-6">
                      <SelectInput
                        options={InmateDrpList}
                        value={findPhotos.InmateID}
                        onChange={(selectedOption) => handleSelectChange(selectedOption, 'InmateID')}
                        name="InmateID"
                        labelKey="label"
                        valueKey="value"
                        isClearable={true}
                        placeholder={currentLang?.placeholders?.cmbInmate}
                        label={currentLang?.labels?.Inmate}
                        required={true}
                        disabled={findPhotos.InmateID !== 0}  // Disable if an inmate is selected
                      />
                    </div>

                    {/* Subject */}
                    <div className="col-md-6">
                      <TextInput
                        name="Subject"
                        id="Subject"
                        label={currentLang?.labels?.Subject}
                        value={findPhotos.Subject}
                        handleChange={(e) => handleChange(e, 'Subject')}
                        placeholder={currentLang?.labels?.Subject}
                        required={false}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSearch(false);
                          }
                        }}
                      />
                    </div>

                    {/* From Date */}
                    <div className="col-md-4">
                      <DatePickerComponent
                        value={findPhotos?.FromDate}
                        onChange={(date) => handleDateChange(date, 'FromDate')}
                        onBlur={(e) => handleBlur(e, 'FromDate')}
                        name="FromDate"
                        label={currentLang?.labels?.FromDate}
                        required={false}
                        disabled={false}
                        yearDropDown={true}
                        monthDropDown={true}
                        showTimeSelect={false}
                        maxDate={findPhotos?.ToDate !== null && findPhotos?.ToDate !== "" ? findPhotos?.ToDate : new Date()}
                        minDate={new Date("2017-01-01")}
                      />
                    </div>

                    {/* To Date */}
                    <div className="col-md-4">
                      <DatePickerComponent
                        value={findPhotos?.ToDate}
                        onChange={(date) => handleDateChange(date, 'ToDate')}
                        onBlur={(e) => handleBlur(e, 'ToDate')}
                        name="ToDate"
                        label={currentLang?.labels?.ToDate}
                        required={false}
                        disabled={false}
                        yearDropDown={true}
                        monthDropDown={true}
                        showTimeSelect={false}
                        minDate={findPhotos?.FromDate ? findPhotos?.FromDate : new Date("2017-01-01")}
                        maxDate={new Date()}
                      />
                    </div>

                    {/* Status */}
                    <div className="col-md-4">
                      <SelectInput
                        options={StatusOptions}
                        value={findPhotos.StatusOptions}
                        onChange={(selectedOption) => handleSelectChange(selectedOption, 'StatusOptions')}
                        name="Status"
                        labelKey="label"
                        valueKey="value"
                        isClearable={true}
                        placeholder=""
                        label={currentLang?.labels?.Status}
                      />
                    </div>
                  </div>

                  <div className="text-center mt-2">
                    <div className="d-flex justify-content-start">
                      <button
                        type="submit"
                        className="btn btn-success me-2"
                        onClick={() => handleSearch(false)}
                      >
                        <i className="fa-solid fa-magnifying-glass me-1"></i>
                        {currentLang?.buttons?.Search}
                      </button>
                      <button type="button" className="btn btn-grey me-2" onClick={handleReset}>
                        <i className="fa-solid fa-arrow-rotate-left me-1"></i>
                        {currentLang?.buttons?.Reset}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <ul className="list-group mt-3 border-radius-all shadow-sm" id="divLoadList">
              {loading ? (
                <div className="alert alert-info text-center" role="alert">
                  {currentLang?.ArchivedPage?.Loading}
                </div>
              ) : isSearch && filteredPhotos?.length === 0 && !previousFilteredPhotos?.length ? (
                <div className="alert-light-red mb-3 font-size-16 p-3 text-center">
                  {currentLang?.info?.NoResult}
                </div>
              ) : (
                filteredPhotos?.map((photo, index) => (
                  <li
                    className="list-group-item d-flex align-items-center justify-content-between flex-wrap cursor-pointer"
                    onClick={() => handleClick(photo)}
                    key={index} // Use unique key
                  >
                    {/* Photo details */}
                    <div className="d-flex align-items-center message-area-disc m-w-100 mo-mb-10">
                      <i className="fa fa-user-circle fa-2x me-3" aria-hidden="true"></i>
                      <div>
                        <label className="fw-bold mb-0 profile-Name"> {photo.PhotoTo}</label>
                        <br />
                        <span className="text-muted msg-desc hidden-text">{photo.PhotoSubject}</span>
                      </div>
                    </div>
                    <div className="justify-content-end">
                      <div>
                        <span className="text-muted float-right position-mobile">
                          {photo.PhotoSendDateTime}
                        </span>
                      </div >
                      <div className="d-flex justify-content-end align-items-center flex-wrap ml-15">
                        <div className="me-2">
                          {photo.PhotoReadStatus === 'Read' && (
                            // <i title={currentLang?.DropDown?.Read} className="fas fa-eye text-dark" ></i>
                            <span className="tick-icon read" title={currentLang?.DropDown?.Read}><img src={messageRead}></img></span>

                          )}
                          {photo.PhotoReadStatus === 'Waiting' && (
                            // <i title={currentLang?.DropDown?.Waiting} className="fa fa-hourglass-start text-dark"></i>
                            <i title={currentLang?.DropDown?.Waiting} className="fa fa-clock"></i>
                          )}
                          {photo.PhotoReadStatus === 'Unread' && (
                            <span className="tick-icon sent" title={currentLang?.DropDown?.Unread}><img src={messagesent}></img></span>
                            // <i title={currentLang?.DropDown?.Unread} className="fa fa-eye-slash text-dark" ></i>
                          )}
                          {photo.PhotoReadStatus === 'Rejected' && (
                            <i title={currentLang?.DropDown?.Rejected} className="fa fa-thumbs-down text-dark" ></i>
                          )}
                        </div>

                        {photo.IsAllowSendReply === 1 && photo.Blocked === 0 && (<button
                          id="btnBuyCredits"
                          type="button"
                          title={currentLang?.buttons?.BuyCredits}
                          className="btn btn-success btn-sm ml-10 pad-4"
                          onClick={(event) => handleClickRedirect(event, photo.InmateID)}
                        >
                          {currentLang?.buttons?.BuyCredits}
                        </button>)}


                        <div className="d-flex align-items-center justify-content-center ">
                          <button className="btn btn-blue btn-sm min-width-80 ml-15 cursor-default">
                            <h5 className="available-limit text-white">
                              ${parseFloat(photo.CreditBalance).toFixed(2) || '0.00'}
                            </h5>
                          </button>

                        </div>

                      </div>
                    </div>
                  </li>
                ))
              )}
              {hasMoreData && filteredPhotos?.length > 0 && (
                <li className="list-group-item">
                  <div className="d-flex justify-content-center mb-n3">
                    <div className="div-load-more-data inbox panel footer-load-more">
                      <label
                        className="text-decoration-none fs-5 cursor-pointer load-more load-more-button"
                        onClick={isSearch ? () => handleSearch(true) : handleLoadMore}
                      >
                        <i class="fa-solid fa-plus me-1 font-size-14"></i>{currentLang?.buttons?.LoadMore}
                      </label>
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </ul>
        </div>
      </div>
      {loader}
      <ConfirmationModal
        show={isPurchaseHistoryConfirm}
        onHide={handleCancelPurchaseHist}
        onConfirm={handleClickPurchaseCreditRedirect}
        title={currentLang?.Message}
        message={currentLang?.ArchivedPagePopContent?.Redirect_Page}
        closeButton={false}
        onconfirmname={currentLang?.buttons?.Yes}
        oncancelname={currentLang?.buttons?.No}
      />

      <ConfirmationModal
        show={isPaymentMsg}
        onHide={handlePaymentMsg}
        onConfirm={handlePaymentMsg}
        title={currentLang?.Message}
        message={paymentMsg}
        showCancelButton={false}
        onconfirmname={currentLang?.buttons?.OK}
      />
    </>
  );
};

export default React.memo(SendPhotos);
